import { format } from "date-fns";
import { NavLink } from "react-router-dom";
import { useState } from "react";

const Footer = () => {
  const [openInfo, setOpenInfo] = useState(false);
  const [openSalas, setOpenSalas] = useState(false);
  const [openUsuarios, setOpenUsuarios] = useState(false);

  return (
    <footer className="bg-black pt-4">
      <div className="container d-none d-md-block">
        <div className="row">
          <div className="col-md-1 d-flex justify-content-center justify-content-md-center me-2">
            <img
              src="/assets/img/marca/antesala-logo-white.svg"
              width="100px"
              alt=""
            />
          </div>
          <div className="col-md-2">
            <ul className="mb-0 p-0">
              <li className="pb-2 d-none">
                <NavLink to="/somos" className="GothamLight fc-blanco">
                  Quienes Somos
                </NavLink>
              </li>
              <li className="pb-2">
                <a href="#" className="GothamLight fc-blanco text-white">
                  Pauta con nosotros
                </a>
              </li>
              <li className="pb-2">
                <NavLink
                  to="/terminos-y-condiciones"
                  className="GothamLight fc-blanco text-white"
                >
                  Términos y Condiciones
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2">
            <h1
              className="GothamLight fc-blanco mt-4 mt-md-0 fw-bold text-white"
              style={{ fontSize: "13px" }}
            >
              SALAS Y PRODUCTORXS
            </h1>
            <ul className="p-0">
              <li className="pb-2">
                <NavLink to="/login" className="GothamLight text-white">
                  Iniciar Sesión
                </NavLink>
              </li>
              <li className="pb-2">
                <NavLink to="/registro/2" className="GothamLight fc-blanco text-white">
                  Registrarse
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2">
            <h1
              className="GothamLight fc-blanco mt-4 mt-md-0 fw-bold text-white"
              style={{ fontSize: "13px" }}
            >
              USUARIOS
            </h1>
            <ul className="mb-0 p-0">
              <li className="pb-2">
                <NavLink to="/login" className="GothamLight fc-blanco text-white">
                  Iniciar Sesión
                </NavLink>
              </li>
              <li>
                <NavLink to="/registro/2" className="GothamLight fc-blanco text-white">
                  Registrate
                </NavLink>
              </li>
              <li className="pb-2">
                <NavLink to="/restaurar" className="GothamLight fc-blanco text-white">
                  Recuperar Cuenta
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2">
            <ul className="mb-0 p-0 mt-4 mt-md-0">
              <li className="pb-2">
                <a href="#" className="fs-3 fc-blanco me-2">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="#" className="fs-3 fc-blanco me-2">
                  <i className="bi bi-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#" className="GothamLight fc-blanco">
                  antesala.cordoba@gmail.com
                </a>
              </li>
              <li className="d-flex">
                <img
                  src="/assets/img/tarjeta-naranja.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/mastercard.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/maestro.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/cabal.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/amex.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/visa.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container d-block d-md-none">
        <div className="row">
          <div className="col-md-2">
            <button
              className="w-100  text-start btn btn-transparent d-flex justify-content-between px-2 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseInfo"
              aria-expanded={openInfo}
              aria-controls="collapseInfo"
              onClick={() => setOpenInfo(!openInfo)}
            >
              INFO
              <i className={`bi bi-chevron-${openInfo ? 'up' : 'down'}`}></i>
            </button>

            <div className="collapse px-2" id="collapseInfo">
              <ul className="mb-0 p-0">
                <li className="py-2 d-none">
                  <NavLink to="/somos" className="GothamLight fc-blanco">
                    Quienes Somos
                  </NavLink>
                </li>
                <li className="py-2">
                  <a href="#" className="GothamLight fc-blanco">
                    Pauta con nosotros
                  </a>
                </li>
                <li className="pb-2">
                  <NavLink
                    to="/terminos-y-condiciones"
                    className="GothamLight fc-blanco text-white"
                  >
                    Términos y Condiciones
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-2">
            <button
              className="w-100 d-flex justify-content-between  text-start btn btn-transparent px-2 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSalasProductores"
              aria-expanded={openSalas}
              aria-controls="collapseSalasProductores"
              onClick={() => setOpenSalas(!openSalas)}
            >
              SALAS Y PRODUCTORXS
              <i className={`bi bi-chevron-${openSalas ? 'up' : 'down'}`}></i>
            </button>

            <div className="collapse px-2" id="collapseSalasProductores">
              <ul className="p-0">
                <li className="py-2">
                  <NavLink to="/login" className="GothamLight fc-blanco text-white">
                    Iniciar Sesión
                  </NavLink>
                </li>
                <li className="">
                  <NavLink to="/registro/2" className="GothamLight fc-blanco text-white">
                    Registrarse
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-2">
            <button
              className="w-100 d-flex justify-content-between  text-start btn btn-transparent px-2 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseUsuarios"
              aria-expanded={openUsuarios}
              aria-controls="collapseUsuarios"
              onClick={() => setOpenUsuarios(!openUsuarios)}
            >
              USUARIOS
              <i className={`bi bi-chevron-${openUsuarios ? 'up' : 'down'}`}></i>
            </button>

            <div className="collapse px-2" id="collapseUsuarios">
              <ul className="mb-0 p-0">
                <li className="py-2">
                  <NavLink to="/login" className="GothamLight fc-blanco text-white">
                    Iniciar Sesión
                  </NavLink>
                </li>
                <li className="pb-2">
                  <NavLink to="/registro/2" className="GothamLight fc-blanco text-white">
                    Registrate
                  </NavLink>
                </li>
                <li className="pb-2">
                  <NavLink to="/restaurar" className="GothamLight fc-blanco text-white">
                    Recuperar Cuenta
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-2 py-2 ">
            <ul className="list-group  list-group-horizontal  d-flex align-items-center">
              <li className="list-group-item bg-transparent border-0">
                <img
                  src="/assets/img/marca/antesala-logo-white.svg"
                  width="50px"
                  alt=""
                />
              </li>
              <li className="list-group-item bg-transparent border-0 d-flex">
                <a href="#" className="fs-3 fc-blanco me-2">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="#" className="fs-3 fc-blanco me-2">
                  <i className="bi bi-instagram"></i>
                </a>
              </li>
              <li className="list-group-item bg-transparent border-0">
                <a href="#" className="GothamLight text-white" style={{ fontSize: "12px" }}>
                  antesala.cordoba@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white p-2">
        <p className="Grifter m-0" style={{ fontSize: "12px" }}>{`© Copyright - 2022 - ${format(
          new Date(),
          "Y"
        ).toString()} | Antesala.`}</p>
      </div>
    </footer>
  );
};

export default Footer;
